import features = require('diy/util/features');
import {SiteadminController} from "SiteadminController";
import OnboardingGuide from "diy/site-admin/onboarding-guide/OnboardingGuide";
import {Observable, TrackerKPI} from "diy/util/Observable";
import {App as NotificationApp} from 'diy/toolbar/notification/App';
import NotificationApi from 'diy/toolbar/notificationNG/Api';

let SiteAdminApi = require<any>('diy/site-admin/main/api');
let SiteAdmin = require<any>("diy/site-admin/main/siteadmin");

/**
 * Class for onboarding guide
 *
 * @class OnboardingGuide
 * @depends jquery.js, controller.js
 * @author Andrei Ion
 */
class Controller implements SiteadminController {

    private controllerLoaded = false;
    private guide: OnboardingGuide;
    private observable: Observable;

    constructor() {
        this.observable = new Observable();
        this.guide = new OnboardingGuide(
            this.observable,
            $(window),
            () => {
                SiteAdminApi.close();
            }
        );
    }

    afterFillContent(el: HTMLElement, response: any, contentElement: JQuery) {
        this.disableNotifications();

        this.guide.setElement(contentElement.get(0));
        if (response.success === true) {
            this.guide.setData(response.data);
        }
        const params = SiteAdmin.getParams();
        if (params && params.hideSidebar) {
            this.guide.setSidebar(false);
        }
        if (params && params.jumpToStep) {
            this.guide.setStep(params.jumpToStep);
        }
        this.guide.setVisible();

        this.controllerLoaded = true;
    };

    addTrackerToOnboardingGuide(tracker: TrackerKPI) {
        this.observable.registerObserver(tracker);
    }

    allowSwitch() {
        return this.controllerLoaded;
    };

    show() {
        /**
         * No need for implementation here because show is called in afterFillContent.
         * And afterFillContent is called every time onboarding Guide is opened because caching is disabled
         * (otherwise the data won't be retreived from the server each time)
         */
    };

    hide() {
        this.guide.setHidden();
        this.enableNotifications();
    };

    getWindowSize() {
        return this.guide.getWindowSize();
    }

    private disableNotifications() {
        SiteAdminApi.closeCallout('cc-sa-item-onboardingguide');
        if (features('notificationsNG')) {
            NotificationApi.schedule(() => {
                NotificationApi.pause();
            });
        } else {
            NotificationApp.getNotificationApi().pause();
        }
    }

    private enableNotifications() {
        if (features('notificationsNG')) {
            NotificationApi.schedule(() => {
                NotificationApi.resume();
            });
        } else {
            NotificationApp.getNotificationApi().resume();
        }
    }

}

let controllerInstance = new Controller();
controllerInstance.addTrackerToOnboardingGuide(new TrackerKPI());
export = controllerInstance;



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/main/controllers/onboardingGuide.ts
 **/